export function composeAttributePath(options) {
    const { attributeId, configurationObjectPath } = options;
    const separator = configurationObjectPath.endsWith("/") ? "" : "/";
    return `${configurationObjectPath}${separator}${attributeId}`;
}
//# sourceMappingURL=composeAttributePath.js.map